import React, { Component } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

import './sparePartDeliverySettingEditModal.scss'

// Utils
import { translation } from '../../../utils/helpers'

// Components
import Modal from '../../components/Modal'

// Elements
import DropDown from '../../elements/dropDown'
import Button from '../../elements/button'
import Divider from '../../elements/divider'
import Confirm from '../../components/Confirm'
import Portal from '../../components/Portal'

class SparePartDeliverySettingEditModal extends Component {
  constructor (props) {
    super(props)

    this.state = {
      brands: [],

      isLoading: false,
      showConfirm: false
    }

    this.onClose = this.onClose.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onClick = this.onClick.bind(this)
    this.onPortalClose = this.onPortalClose.bind(this)
  }

  componentDidMount () {
    this.updateSelectedBrands(this.props)
  }

  componentWillReceiveProps (nextProps) {
    if (!isEqual(nextProps.selected, this.props.selected)) {
      this.updateSelectedBrands(nextProps)
    }
  }

  updateSelectedBrands (props) {
    this.setState({
      brands: props.selected
    })
  }

  onClose () {
    this.setState({
      isLoading: false
    })

    if (this.props.onClose) {
      this.props.onClose()
    }
  }

  onChange (e) {
    const { name, value } = e.target

    this.setState({
      [name]: value
    })
  }

  onClick () {
    if (this.state.brands.length === 0 && this.state.showConfirm === false) {
      this.setState({
        showConfirm: true
      })
      return
    }

    if (this.props.onSave !== null) {
      this.setState({
        isLoading: true,
        showConfirm: false
      })

      this.props.onSave(this.state.brands).then(() => {
        this.onClose()
      })
    }
  }

  onPortalClose () {
    this.setState({
      showConfirm: false
    })
  }

  render () {
    const brandOptions = this.props.brands.map((b, index) => {
      if (index === 0) {
        return { value: b.Name, label: translation(b.Name), disabled: true }
      }

      return { value: b.Name, label: b.Name }
    })

    let buttonLabel = translation('791')
    if (this.state.isLoading) {
      buttonLabel = (
        <div className='animated-background'>
          <i className='fa fa-spinner fa-spin fa-3x fa-fw' />
          <span className='sr-only'>{translation('13382')}...</span>
        </div>
      )
    }

    return (
      <div className='sparePartDeliverySettingModal'>
        <Modal
          {...this.props}
          header={translation('13473')}
          onClose={this.onClose}
        >
          <div className='sparePartDeliverySettingModal__content'>
            <DropDown
              name='brands'
              value={this.state.brands}
              onChange={this.onChange}
              options={brandOptions}
              isMulti
            />

            <Divider spacing={3} noLine />
            <Button onClick={this.onClick} labelText={buttonLabel} />

            {this.state.showConfirm && (
              <Portal className='confirm_popup' onPortalClose={this.onPortalClose}>
                <Confirm
                  confirm={this.onClick}
                  notConfirm={this.onPortalClose}
                  renderText={() => translation('16526')}
                />
              </Portal>
            )}
          </div>
        </Modal>
      </div>
    )
  }
}

SparePartDeliverySettingEditModal.defaultProps = {
  onSave: null
}

function mapStateToProps (state) {
  return {
    brands: state.common.brands
  }
}

export default connect(mapStateToProps)(SparePartDeliverySettingEditModal)



// WEBPACK FOOTER //
// ./src/app/shared/modals/SparePartDeliverySettingEditModal/index.js